import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import {
    Chip,
    List,
    Alert,
    AlertTitle,
    Typography,
    ListItemText,
} from "@mui/material/";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import TaskAltIcon from "@mui/icons-material/TaskAlt";

export default ({ groupAudit }) => {
    const { t } = useTranslation();

    const { auditUpload } = useSelector((state) => state);

    const checkDealerForm = (upload) => {
        if (!upload) return false;
        if (upload) {
            /** If required signature form details are not filled */
            const {
                dealerContactName,
                dealerContactEmail,
                dealerContactRole,
                dealerContactSignature,
                auditorSignature,
            } = upload.auditSignature;

            if (
                dealerContactName?.length > 0 &&
                dealerContactEmail?.length > 0 &&
                dealerContactRole !== "" &&
                dealerContactSignature?.length > 0 &&
                auditorSignature?.length > 0
            )
                return true;
            else return false;
        }
    };

    return (
        <Alert severity="info">
            <AlertTitle>{t("submitGroup")}</AlertTitle>
            {t("messages.groupAuditSubmit")}
            <List>
                {groupAudit.map((card) => (
                    <ListItemText
                        component="div"
                        key={card.auditId}
                        primary={card.locationName}
                        secondary={
                            <Typography component="div">
                                <Chip
                                    sx={{
                                        border: "none",
                                    }}
                                    icon={
                                        <>
                                            {checkDealerForm(
                                                auditUpload[card.auditId]
                                            ) ? (
                                                <TaskAltIcon color="success" />
                                            ) : (
                                                <WarningAmberIcon color="warning" />
                                            )}
                                        </>
                                    }
                                    label={t("signature")}
                                    variant="outlined"
                                />
                            </Typography>
                        }
                    />
                ))}
            </List>
        </Alert>
    );
};
